import React, { lazy } from 'react'
import Loadable from 'app/components/Loadable/Loadable'

const NotFound = Loadable(lazy(() => import('./NotFound')))
const ForgotPassword = Loadable(lazy(() => import('./forgot-password/ForgotPassword')))
const ResetPassword = Loadable(lazy(() => import('./reset-password/ResetPassword')))
const JwtLogin = Loadable(lazy(() => import('./login/JwtLogin')))
const JwtRegister = Loadable(lazy(() => import('./register/JwtRegister')))
const Profile = Loadable(lazy(() => import('../PersonalInfo/Profile')))
const Password = Loadable(lazy(() => import('../PersonalInfo/Password')))
const sessionRoutes = [
    {
        path: '/session/signup',
        element: <JwtRegister />,
    },
    {
        path: '/session/signin',
        element: <JwtLogin />,
    },
    {
        path: '/session/forgot-password',
        element: <ForgotPassword />,
    },
    {
        path: '/session/reset-password/:resetPasswordToken',
        element: <ResetPassword />,
    },
    {
        path: '/session/404',
        element: <NotFound />,
    },
    {
        path: '/dashboard/user-profile',
        element: <Profile />,
    },
    {
        path: '/dashboard/user-password',
        element: <Password />,
    },
]

export default sessionRoutes
